import moment from "moment";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class SentEmailService extends ApiService {
    template = "defaultTemplate";
    namespace = "sent-email";
    listingRelations = "emailName";
    relations = "?expand=email";
    icon = "MailsWithArrow";
    favicon = "MailsWithArrow";
    DOMAIN = 210;
    action = "action";

    search = true;
    singular = this.terminology.sentEmail.singular;
    plural = this.terminology.sentEmail.plural;
    vowel = this.terminology.sentEmail.vowel;
    name = `${this.vowel} ${this.singular}`;
    Width = 1200;
    gemItems = [
        {
            key: "create",
            label: this.t("addAnEntity", { entity: this.singular }),
            icon: PrimeIcons.PLUS_CIRCLE,
        },
        {
            key: "listing",
            label: this.t("allEntity", { entity: this.plural }),
            icon: PrimeIcons.LIST,
        },
        {
            key: "create",
            label: this.t("addAnEntity", {
                entity: this.terminology.emailTemplate.singular,
            }),
            icon: PrimeIcons.PLUS_CIRCLE,
            services: -21,
        },
        {
            key: "listing",
            label: this.t("allEntity", {
                entity: this.terminology.emailTemplate.plural,
            }),
            icon: PrimeIcons.LIST,
            services: -21,
        },
        {
            key: "listing",
            label: this.t("allEntity", {
                entity: this.terminology.emailSignature.plural,
            }),
            icon: PrimeIcons.LIST,
            services: 209,
        },
    ];
    listMenuItems = [
        {
            key: "edit",
            label: "Edit " + this.name,
            icon: "edit",
        },
    ];
    columns = [
        {
            header: this.t("Address"),
            icon: "Tag",
            field: "to_email",
        },
        {
            header: this.t("subject"),
            icon: "Tag",
            field: "subject",
        },
        {
            header: this.t("email"),
            icon: "Email",
            field: "emailName",
        },
        {
            header: this.t("status"),
            icon: "Mails",
            field: "is_sent",
            template: (data) => {
                return !data.status
                    ? "Pending (Queued)"
                    : data.status == 1
                        ? "Sent"
                        : "Declined";
            },
        },
        {
            header: this.t("date"),
            icon: "GreenCalendar",
            field: "date",
            template: (data) => {
                return moment.unix(data.created_at).format("MM/DD/YYYY");
            },
        },
    ];
    filterItems = [
        {
            name: "Emails",
            icon: "Email",
            key:"email_id",
            serviceId: "208",
            params: { realm: 1 },
            item: { key: 'id', label: 'display_name' },
            value: "-2",
            realm: "0",
            selected: true,

        },
    ];
    getActionMenu(item) {
        let listMenuItems = [
            {
                key: "detail",
                label: this.t("viewEntity", { entity: this.singular }),
                icon: "Eye",
            },

        ];
        return listMenuItems;
    }

    constructor() {
        super("sent-emails");
    }

    async getListFilter(service) {
        if (service) {
            return this.store
                .dispatch("fetch/refresh", {
                    serviceId: service.serviceId,
                    data: { ...service.params },
                })
                .then((res) => {
                    return res[service.serviceId];
                });
        }
        return null;
    }
}
